export var ACTIVATE_MEMBER_OPTION_ID = 'ACTIVATE_MEMBER_OPTION_ID';
export var HOUSEHOLD_OPTION_ACTIVATE_ID = 'HOUSEHOLD_OPTION_ACTIVATE_ID';
export var HOUSEHOLD_OPTION_EDIT_ID = 'HOUSEHOLD_OPTION_EDIT_ID';
export var HOUSEHOLD_OPTION_REMOVE_ID = 'HOUSEHOLD_OPTION_REMOVE_ID';
export var REMOVE_MEMBER_OPTION_ID = 'remove_member_option_id';
export var EDIT_PRIVILEGES_ID = 'edit_privileges_id';
export var HOUSEHOLD_STATE_NAME = 'index.customercare.customer.household';